export default {
  pageFilters: [
    {
      id: 'content',
      label: 'Content',
      filters: {
        season: null,
        episode: null
      }
    },
    {
      id: 'users',
      label: 'Users',
      filters: {
        country: null,
        panel: null,
        gender: null,
        age: null
      }
    }
  ],
  looks: {
    showReactions: {
      fields: ['age', 'country', 'episode', 'gender', 'season']
    }
  },
  pageTitle: 'Reactions vs. Social Engagement',
  pageId: 'episodeEngagementAndEmotionVote'
};
